import React from "react";
import "../style/emr_overall_style.scss";
import { Link } from "react-router-dom";

const EmrFooter = () => {
    const currentYear = new Date().getFullYear();
    return (
        <footer className="emr-footer">
            <nav className="footer-link-group">
                <Link to="/" className="footer-link">Home</Link>
                <span className="footer-separator">·</span>
                <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
            </nav>
            <div className="footer-copyright">
                Copyright Reserved, Board of Trustees of the University of Illinois, {currentYear}
            </div>
        </footer>
    )
}

export default EmrFooter;